export default __webpack_public_path__ + "static/media/terms-and-conditions.85bdaf81.pdf";